import type { Dictionnaire } from '../type';

export const carte: Dictionnaire['carte'] = {
  ecran: {
    voirTout: '查看全部',
    dansLaZone: '仅此区域',
    impossible: '暂时无法完成。',
    recherchePosition: '正在定位…',
    activerLocalisation: '开启定位即可在地图上看到自己',
    unSansAdresse: '有 1 个活动没有精确地址，未在地图上显示。',
    revenir: '回到我的位置',
    personneInscrit: '还没有人报名',
    inscrit: '你已报名',
    demandeEnvoyee: '申请已发送',
    listeAttente: '加入候补名单',
    rejoindre: '参加这个活动',
    plusTard: '以后再说',
    aucun: '没有活动',
    un: '1 个活动',
    videCarte: '地图上还没有活动。新活动会自动出现在这里。',
    videZone: '地图的这片区域没有活动。缩小或移动地图看看其他地方。',
    sansAdresse: (n: number) => `有 ${n} 个活动没有精确地址，未在地图上显示。`,
    participants: (n: number) => `${n} 位参与者`,
    memeEndroit: (n: number) => `同一地点的 ${n} 个活动`,
    plusieurs: (n: number) => `${n} 个活动`,
  },
  apple: {
    pasOuverte: 'Apple 地图无法打开。',
    pasChargee: 'Apple 地图无法加载。',
  },
  libre: {
    pasAffichee: '此设备无法显示地图。',
    pasChargee: '地图无法加载。请检查网络连接。',
  },
  placer: {
    titre: '在校园中定位',
    deplacer: '拖动标记来调整位置。',
    toucher: '点击地图上活动所在的位置。',
    placerIci: '放在这里',
  },
  pastilles: {
    maPosition: '我的位置',
    sortie: (titre: string, categorie: string, spontanee: boolean) =>
      `${titre}，${categorie}${spontanee ? '，临时活动' : ''}`,
    groupe: (n: number) => `此处有 ${n} 个活动`,
  },
  maquette: {
    pasAffichee: '此设备无法显示模型。',
  },
  placerMaquette: {
    pasAffichee: '此设备无法显示模型。',
    deplacer: '点击其他位置即可移动。',
    toucher: '点击模型上活动所在的位置。',
  },
  apercu: {
    credits: '© OpenStreetMap · OpenFreeMap',
    carteDuLieu: (lieu: string) => `地点地图：${lieu}`,
  },
};
